"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CapabilityStatement_Interaction1 = exports.CapabilityStatement_Interaction1CodeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var CapabilityStatement_Interaction1CodeKind;
(function (CapabilityStatement_Interaction1CodeKind) {
    CapabilityStatement_Interaction1CodeKind["_transaction"] = "transaction";
    CapabilityStatement_Interaction1CodeKind["_batch"] = "batch";
    CapabilityStatement_Interaction1CodeKind["_searchSystem"] = "search-system";
    CapabilityStatement_Interaction1CodeKind["_historySystem"] = "history-system";
})(CapabilityStatement_Interaction1CodeKind = exports.CapabilityStatement_Interaction1CodeKind || (exports.CapabilityStatement_Interaction1CodeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_CapabilityStatement_Interaction1 = t.recursion('ICapabilityStatement_Interaction1', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        code: (0, EnumType_1.createEnumType)(CapabilityStatement_Interaction1CodeKind, 'CapabilityStatement_Interaction1CodeKind'),
        _code: RTTI_Element_1.RTTI_Element,
        documentation: RTTI_markdown_1.RTTI_markdown,
        _documentation: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_CapabilityStatement_Interaction1.js.map